<template>
  <v-container class="fill-height">
    <v-row class="ma-0 font-weight-bold">
      Si estás teniendo problemas para realizar tu pago, intenta refrescar la
      página con Ctrl + Shift + R.
    </v-row>
    <v-row justify="center">
      <v-col cols="12" class="white">
        <v-row justify="center">
          <v-col>
            <v-tabs
              :fixed-tabs="$vuetify.breakpoint.smAndDown"
              :color="color.primaryVariant"
              :value="tabSwitch"
              class="font-weight-bold"
            >
              <v-tab :disabled="!hasDebts">
                <span class="body-2 font-weight-bold"> Cuotas Atrasadas </span>
              </v-tab>
              <v-tab :disabled="hasDebts || hasActivePlan">
                <span class="body-2 font-weight-bold"> Cuota Actual </span>
              </v-tab>
              <v-tab :disabled="!hasActivePlan">
                <span class="body-2 font-weight-bold"> Pagos Parciales </span>
              </v-tab>

              <v-tab-item v-if="hasDebts">
                <div v-if="debtStep == 0">
                  <v-row justify="center" class="ma-0 my-4">
                    <v-col cols="8">
                      <span class="text-body-2">
                        <v-icon color="blue darken-3">mdi-alert</v-icon>
                        Tienes los siguientes adeudos pendientes, una vez
                        cubiertos podrás ir a la siguiente pestaña a realizar tu
                        pago de la cuota actual.
                      </span>
                    </v-col>
                  </v-row>

                  <v-row
                    justify="center"
                    class="ma-0"
                    v-for="debt in debts"
                    :key="debt._id"
                  >
                    <v-col cols="8">
                      <v-row justify="space-between">
                        <v-col cols="7" class="text-end">
                          <span> {{ debt.description }} </span>
                        </v-col>

                        <v-col cols="3">
                          <span class="text-body-2">
                            $ {{ formatAmount(debt.amount) }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0">
                    <v-col cols="8">
                      <v-row justify="space-between">
                        <v-col cols="7" class="text-end font-weight-black">
                          <span> TOTAL </span>
                        </v-col>

                        <v-col cols="3">
                          <span class="text-body-2 font-weight-bold">
                            $ {{ formatAmount(totalAmount) }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn
                        color="blue darken-2"
                        class="white--text px-6"
                        rounded
                        @click="createOrder()"
                      >
                        Pagar
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="debtStep == 1">
                  <DebtCheckout :orderProp="order">
                    <v-row
                      justify="center"
                      class="ma-0"
                      v-for="debt in debts"
                      :key="debt._id"
                    >
                      <v-col cols="8">
                        <v-row justify="space-around">
                          <v-col cols="7" class="text-start">
                            <span> {{ debt.description }} </span>
                          </v-col>

                          <v-col cols="3">
                            <span class="text-body-2">
                              $ {{ formatAmount(debt.amount) }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row justify="center" class="ma-0">
                      <v-col cols="8">
                        <v-row justify="space-around">
                          <v-col cols="7" class="font-weight-black">
                            <span> TOTAL </span>
                          </v-col>

                          <v-col cols="3">
                            <span class="text-body-2 font-weight-bold">
                              $ {{ formatAmount(totalAmount) }}
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </DebtCheckout>
                </div>
              </v-tab-item>

              <v-tab-item v-else>
                <v-row justify="center" class="ma-0 my-4">
                  <v-col cols="8">
                    <span class="text-body-2">
                      <v-icon x-large color="green darken-3">mdi-check</v-icon>
                      No tienes ningún adeudo pendiente, puedes ir a la
                      siguiente pestaña a realizar tu pago de la cuota actual.
                    </span>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item v-if="!hasDebts && !hasActivePlan">
                <ContinuePayment
                  :setStep="$route.params.setStep"
                  :memberId="$route.params.memberId"
                  :memberBranchId="$route.params.memberBranchId"
                >
                </ContinuePayment>
              </v-tab-item>

              <v-tab-item v-else-if="hasActivePlan">
                <v-row justify="center" class="ma-0 my-4">
                  <v-col cols="8">
                    <span class="text-body-2">
                      <v-icon x-large color="blue darken-3">mdi-alert</v-icon>
                      Ya cuentas con un plan de pagos parciales activo.
                      Dirígete a la pestaña de Pagos Parciales para continuar
                      con tus pagos.
                    </span>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-else>
                <v-row justify="center" class="ma-0 my-4">
                  <v-col cols="8">
                    <span class="text-body-2">
                      <v-icon x-large color="red darken-3"
                        >mdi-close-thick</v-icon
                      >
                      No puedes continuar con el proceso de pago hasta que
                      cubras tus adeudos pendientes.
                    </span>
                  </v-col>
                </v-row>
              </v-tab-item>

              <!-- Tab: Pagos Parciales -->
              <v-tab-item>
                <v-row justify="center" class="ma-0 my-4">
                  <v-col cols="12" sm="8">
                    <template v-if="hasActivePlan">
                      <v-row class="mb-1" no-gutters align="center">
                        <v-col>
                          <span class="caption">{{ activePlan.paidInstallments }} de {{ activePlan.installmentsCount }} cuotas pagadas</span>
                        </v-col>
                      </v-row>
                      <v-progress-linear
                        :value="progressPercent"
                        :color="color.primaryVariant"
                        background-color="#d6f6ff"
                        rounded
                        height="8"
                        class="mb-4"
                      ></v-progress-linear>

                      <v-simple-table dense>
                        <template #default>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Monto</th>
                              <th>Fecha límite</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="inst in activePlan.installments" :key="inst.number">
                              <td>{{ inst.number }}</td>
                              <td>{{ formatCurrency(inst.amount) }}</td>
                              <td>{{ formatDate(inst.dueDate) }}</td>
                              <td>
                                <v-chip
                                  x-small
                                  class="white--text"
                                  :style="{ backgroundColor: installmentStatusColor(inst.status) }"
                                >
                                  {{ installmentStatusLabel(inst.status) }}
                                </v-chip>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <v-row v-if="nextInstallment" class="mt-4" justify="center">
                        <v-btn
                          :style="{ backgroundColor: color.primaryVariant }"
                          class="white--text font-weight-bold text-capitalize rounded-pill"
                          @click="goToPayInstallment"
                        >
                          Pagar cuota {{ nextInstallment.number }}
                        </v-btn>
                      </v-row>
                    </template>
                    <template v-else>
                      <span class="text-body-2">No tienes ningún plan de pagos parciales activo.</span>
                    </template>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-btn
          :color="color.primaryVariant"
          class="text-uppercase rounded-pill white--text font-weight-bold"
          :to="getBackToProfiles().route"
        >
          <v-icon>mdi-chevron-left</v-icon>
          {{ getBackToProfiles().label }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { colors } from "@/constants/colors.js";
import DebtCheckout from "./debtCheckout.vue";
import ContinuePayment from "../newAffiliate/index.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "Payments",
  components: {
    DebtCheckout,
    ContinuePayment,
  },
  data() {
    return {
      color: colors,
      debts: [],
      order: {},
      debtStep: 0,
    };
  },
  computed: {
    ...mapState("membershipProfile", ["userMembership"]),
    ...mapState("user", ["user"]),
    ...mapState("paymentPlan", ["memberPaymentPlans"]),
    hasDebts() {
      return this.debts.length > 0;
    },

    hasActivePlan() {
      return this.memberPaymentPlans.some((p) => p.status === 'ACTIVE');
    },

    activePlan() {
      return this.memberPaymentPlans.find((p) => p.status === 'ACTIVE') || null;
    },

    nextInstallment() {
      if (!this.activePlan || !Array.isArray(this.activePlan.installments)) return null;
      return this.activePlan.installments.find((i) => i.status === 'PENDING') || null;
    },

    progressPercent() {
      if (!this.activePlan || !this.activePlan.installmentsCount) return 0;
      return Math.round((this.activePlan.paidInstallments / this.activePlan.installmentsCount) * 100);
    },

    totalAmount() {
      let total = 0;
      this.debts.forEach((debt) => {
        total += debt.amount;
      });
      return total;
    },

    tabSwitch() {
      if (this.hasActivePlan) return 2;
      return this.debts.length > 0 ? 0 : 1;
    },
  },
  methods: {
    ...mapActions("paymentPlan", ["fetchMemberPaymentPlans"]),

    goToPayInstallment() {
      this.$router.push({ path: `/member/partial-payment/${this.activePlan._id}` });
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount);
    },

    formatDate(dateStr) {
      if (!dateStr) return 'N/D';
      return new Date(dateStr).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    installmentStatusColor(status) {
      const map = { PENDING: '#9e9e9e', PAID: '#4caf50', OVERDUE: '#f44336' };
      return map[status] || '#9e9e9e';
    },

    installmentStatusLabel(status) {
      const map = { PENDING: 'Pendiente', PAID: 'Pagada', OVERDUE: 'Vencida' };
      return map[status] || status;
    },

    getBackToProfiles() {
      console.log(this.user);
      if (
        (this.validateOrganization() && this.userMembership) ||
        (!this.validateOrganization() && !this.userMembership)
      ) {
        return { label: "Volver al inicio", route: "/member/home" };
      } else if (!this.userMembership && this.validateOrganization()) {
        return {
          label: "Volver a la selección de perfiles",
          route: "/member/affiliation-profile",
        };
      }
      return { label: "Volver al inicio", route: "/member/home" };
    },

    // validates if user organization is ampi (dev || prod)
    validateOrganization() {
      return ["62b622c66a7441ae20159d7d", "6297b0fec7bf8b6f826313be"].includes(
        this.user.headOffice._id
      );
    },

    async getMemberDebts() {
      //uses axios to get member debts
      try {
        const debtsResponse = await this.axios({
          method: "GET",
          url: "debts",
        });

        this.debts = debtsResponse.data.debts;
        console.log(this.debts);
      } catch (error) {
        console.log(error);
      }
    },

    async createOrder() {
      //uses axios to create order
      try {
        const orderResponse = await this.axios({
          method: "POST",
          url: "debts/order-management",
        });

        this.order = orderResponse.data.order;

        this.increaseDebtStep();
      } catch (error) {
        console.log(error);
      }
    },

    increaseDebtStep() {
      this.debtStep++;
    },

    formatAmount(amount) {
      let formattedAmount = amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      formattedAmount += ".00";
      return formattedAmount;
    },
  },

  created() {
    this.getMemberDebts();
    this.fetchMemberPaymentPlans();
  },
};
</script>

<style></style>